import { SHOP } from '@hive/status'
import { NestedFilter } from '@@partner:types:graphql'
import { ShopsFiltersType } from '@components/shop/table/ShopsFilter'
import { makeFilter } from './crud/filters'

export const makeDefaultFilter = (field: string) => ({
  fields: [ field ],
  op: 'unwrap'
})

export const prepareShopsFilter = (filters: ShopsFiltersType): NestedFilter => {
  const nameFilter = makeFilter('name', 'includes', filters.name)
  const addressFilter = makeFilter('address', 'includes', filters.address)
  
  // Объединяем выбранные статусы с архивным если включён чекбокс
  const statuses = [ ...filters.statuses ]
  if (filters.showArchived) {
    statuses.push(SHOP.ARCHIVED)
  }
  const statusFilter = makeFilter('status', 'contains', statuses)
  
  return {
    'and': [
      nameFilter,
      addressFilter,
      statusFilter
    ]
  }
}